import { Form, Modal, ModalFooter } from 'components';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

const ItemFormModal = ({
  isOpen,
  onClose,
  title,
  saveText,
  cancelText,
  formKey,
  initialValues,
  onSubmit,
  canSave,
  children,
}) => {
  const formikRef = useRef(null);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  return (
    <Modal
      open={isOpen}
      wide
      contentStyle={{ maxWidth: '560px' }}
      bodyStyle={{ padding: 0 }}
      header={{ title }}
      closeOnDocumentClick
      onClose={onClose}
      footer={() => (
        <ModalFooter
          onCancel={onClose}
          onSave={() => formikRef.current?.submitForm()}
          cancelText={cancelText}
          saveText={saveText}
          isSaveDisabled={!isSaveEnabled}
        />
      )}
    >
      <div style={{ padding: '24px', overflowY: 'auto' }}>
        <Form
          key={formKey}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={onSubmit}
          renderDefaultButtons={false}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            const isValid = canSave(formikProps.values);
            if (isValid !== isSaveEnabled) setIsSaveEnabled(isValid);

            return children(formikProps);
          }}
        </Form>
      </div>
    </Modal>
  );
};

ItemFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  saveText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  formKey: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  canSave: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};

ItemFormModal.defaultProps = {
  formKey: undefined,
};

export default ItemFormModal;
